<template>
	<div class="view">
		<!-- <el-button>扫码</el-button>
    <span>参数:{{ Code }}</span> -->
		<div
			class="pro"
			v-if="IsShow"
			v-loading="loading"
			:element-loading-spinner="LoadingIcon"
			:element-loading-text="TextTitle"
			:element-loading-background="Background"
			:fullscreen="true"
		>
			<div class="bt">
				<div class="title">
					<!-- {{ (ProductInfo && ProductInfo.ProductName) || "暂无" }} -->
					<img
						class="logo"
						:src="ProductInfo.AppHeadLogo"
						alt=""
						v-if="ProductInfo.AppHeadLogo"
					/>
					<img class="logo" src="@/assets/logo.png" alt="" v-else />
					<div class="switch-area">
						<img
							class="icon"
							src="@/assets/zh.svg"
							alt=""
							v-if="showLang === `zh_cn`"
							@click="handleLang(`en_us`)"
						/>
						<img
							class="icon"
							src="@/assets/en.svg"
							alt=""
							v-else
							@click="handleLang(`zh_cn`)"
						/>
					</div>
				</div>
				<!-- <div class="desc">型号：KF-25GW/PBCA-R5</div> -->
				<!-- 轮播图 -->
				<div class="lunbo">
					<van-swipe
						class="my-swipe"
						:autoplay="5000"
						indicator-color="white"
					>
						<van-swipe-item
							v-for="(item, index) in ProductInfo.ProductImage"
							:key="index"
						>
							<img :src="item" />
						</van-swipe-item>
					</van-swipe>
				</div>
				<!-- 列表数据 -->
				<div class="content">
					<div class="list">
						<div
							class="item"
							@click="PorductJs(item)"
							v-for="item in ProductInfo.QRCodeIntroduces"
							:key="item.QRCodeIntroduceId"
						>
							<img
								class="logo"
								:src="item.Icon"
								alt=""
								v-if="item.Icon"
							/>
							<img
								class="logo"
								src="@/assets/x.png"
								alt=""
								v-else
							/>
							<div class="name">
								{{ item.ProductIntroduceName }}
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="nodata" v-if="IsNoShow">
			<img src="@/assets/nodata.png" />
			<span> {{ $t("abnormal") }}</span>
		</div>
		<Login @changeModelType="getModelStr" v-if="modelStr === 'login'" />
		<Register
			@changeModelType="getModelStr"
			v-if="modelStr === 'register'"
		/>
	</div>
</template>

<script>
import "@/utils/flexible.js";
import { GetProductIntroduceOut } from "@/api/qrcode";
import store from "@/store";
import Login from "./login.vue";
import Register from "./register.vue";

export default {
	name: "ProductManual",
	components: { Login, Register },
	data() {
		return {
			Code: "",
			IsShow: false,
			IsNoShow: false,
			loading: false,
			TextTitle: "数据加载中",
			Background: "rgba(0, 0, 0, 0.9)",
			LoadingIcon: "el-icon-loading",
			ProductInfo: "",
			modelStr: "",
			// ProductImage:[],
		};
	},
	computed: {
		showLang() {
			return store.getters.lang;
		},
	},
	created() {
		const queryUrl = this.getRequest();
		if (queryUrl.code == "undefined" || queryUrl.code == undefined) {
			this.IsShow = false;
			this.IsNoShow = true;
		} else {
			this.IsShow = true;
			this.IsNoShow = false;
			this.Code = queryUrl.code;
			this.GetContent(this.Code);
			sessionStorage.setItem("code", this.Code);
			//this.Test()
		}
	},
	mounted() {},
	methods: {
		handleLang(val) {
			localStorage.setItem("lang", val);
			store.dispatch("settings/setLang", val);
			location.reload();
		},
		PorductJs(item) {
			if (item.IntroduceType === 3) {
				if (store.getters.token) {
					this.$router.push({
						path: "/maintenance",
					});
				} else {
					this.modelStr = "login";
				}
			} else {
				this.$router.push({
					path: "/ProductInfo",
					query: {
						QRCodeIntroduceId: item.QRCodeIntroduceId,
						name: item.ProductIntroduceName,
					},
				});
			}
		},
		getRequest() {
			var url = decodeURIComponent(location.search);
			var theRequest = new Object();
			if (url.indexOf("?") != -1) {
				var str = url.substr(1);
				var strs = str.split("&");
				for (var i = 0; i < strs.length; i++) {
					theRequest[strs[i].split("=")[0]] = unescape(
						strs[i].split("=")[1]
					);
				}
			}
			return theRequest;
		},
		async GetContent(id) {
			const res = await GetProductIntroduceOut(id);
			this.ProductInfo = res.Data;
			document.title = this.ProductInfo.ProductName;

			// var temp = this.ProductInfo.ProductImage[0].split(';')
			// console.log(temp,1111)
			// if(temp.length>0)
			// {
			//   temp.forEach(el => {
			//     this.ProductImage.push(el)
			//   });
			// }
			// console.log(this.ProductImage,2222)
		},
		getModelStr(e) {
			this.modelStr = e;
		},
	},
};
</script>
<style lang="scss">
.el-carousel__container {
	height: 270px;
}
</style>
<style scoped lang="scss">
::v-deep .el-icon-loading {
	font-size: 00.5rem;
}
.view {
	height: 100vh;
	width: 100vw;
	display: flex;
	justify-content: center;
	align-content: center;
	background-color: #798198;
	.pro {
		height: 100vh;
		width: 100vw;
		.bt {
			// background-image: url("~@/assets/bj.png");
			background-position: center;
			background-size: cover;
			display: flex;
			flex-direction: column;
			height: 10.5rem;
			.title {
				position: relative;
				display: flex;
				justify-content: center;
				padding: 15px 0;
				.logo {
					width: 3rem;
				}
				.switch-area {
					position: absolute;
					right: 10px;
					top: 50%;
					transform: translateY(-50%);
					.icon {
						width: 20px;
					}
				}
			}
			.desc {
				font-size: 0.3rem;
				text-align: center;
				margin: 0.3rem 0 0 0;
			}
			.lunbo {
				img {
					display: block;
					width: 100%;
				}
			}
			.content {
				width: 100%;
				padding: 20px;
				box-sizing: border-box;
				background-color: #798198;

				.list {
					margin: auto;
					display: flex;
					flex-direction: row;
					flex-flow: wrap;
					justify-content: space-between;
					.item {
						width: 45%;
						// border: 1px solid #000000;
						height: 3.5rem;
						margin-bottom: 20px;
						// background-image: url("~@/assets/item1.png");
						background-position: center;
						background-size: cover;
						border-radius: 0.2rem;
						display: flex;
						flex-direction: column;
						justify-content: center;
						align-items: center;
						position: relative;
						.logo {
							width: 1.5rem;
						}
						.name {
							margin-top: 10px;
							text-align: center;
							color: #fff;
							font-size: 14px;
						}
					}
					.item:nth-child(n + 1) {
						background-color: #f7ca17;
					}
					.item:nth-child(n + 2) {
						background-color: #593a8a;
					}
					.item:nth-child(n + 3) {
						background-color: #26a65b;
					}
					.item:nth-child(n + 4) {
						background-color: #e67f22;
					}
					.item:nth-child(n + 5) {
						background-color: #0188fb;
					}
				}
			}
		}
	}
	.nodata {
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		img {
			width: 80%;
		}
		span {
			font-size: 0.45rem;
		}
	}
}
</style>
